import { Stack, Typography } from '@mui/material';
import { useTranslation } from '@tyro/i18n';

interface ReportWidgetNoAccessProps {
  hasAccess: boolean;
  children: React.ReactNode;
}

export function ReportWidgetNoAccess({
  hasAccess,
  children,
}: ReportWidgetNoAccessProps) {
  const { t } = useTranslation(['reports']);

  if (hasAccess) {
    return children;
  }

  return (
    <Stack
      sx={{
        position: 'absolute',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      spacing={1}
    >
      <img
        src="/assets/emojis/see_no_evil.png"
        role="presentation"
        alt="Monkey covering eyes"
        width="48"
      />
      <Typography variant="body1" component="span" color="text.secondary">
        {t('reports:noAccess')}
      </Typography>
    </Stack>
  );
}
